import React from 'react';
import { observer } from 'mobx-react';
import { useTranslation } from 'react-i18next';
import { OfferingCardLane } from '@ole-ui/ole-ui-components';
import useMobxStores from 'hooks/useMobxStores';
import { BaseOfferingCard } from 'components/OfferingCards';
import { OfferingTier } from 'types';
import { CommonLaneProps } from './types';

const TrialSubscriptionsLane = ({
  expanded,
  onTitleClick,
}: CommonLaneProps) => {
  const { t } = useTranslation();
  const { catalogStore } = useMobxStores();

  const trialCourses = catalogStore.AvailableToMeEntryProgressPair;

  return (
    <OfferingCardLane
      className="new_lane"
      emptyMessage={
        <p className="empty-message">
          {t(
            "All trial offerings are in progress. You can track them in the 'My Progress' section.",
          )}
        </p>
      }
      expanded={expanded}
      items={trialCourses}
      keyExtractor={(item) => item.doc_id}
      onTitleClick={onTitleClick}
      renderItem={(item) => (
        <BaseOfferingCard
          availableLabel={
            item.tier === OfferingTier.RHLSTrial ? t('Available') : undefined
          }
          entry={item}
          key={item.doc_id}
        />
      )}
      title={t('Available in your trial subscription')}
    />
  );
};

export default observer(TrialSubscriptionsLane);
